module.exports = __webpack_public_path__ + "24e004ab/img/comments-icon.fdec7fdb.svg";